var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['chat-header', _vm.isH5 && 'chat-header-h5']
  }, [_c('div', {
    staticClass: "chat-header-name"
  }, [_vm.isH5 && _vm.props.canCloseChat ? _c('div', {
    class: ['chat-header-back', _vm.isH5 && 'chat-header-h5-back'],
    on: {
      "click": function ($event) {
        return _vm.closeChat(_vm.currentConversation.conversationID);
      }
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.backSVG
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "chat-header-container"
  }, [_vm.showHeaderIcon ? _c('Icon', {
    attrs: {
      "width": _vm.headerIconWidth,
      "height": _vm.headerIconHeight,
      "file": _vm.headerIcon
    }
  }) : _vm._e(), _c('div', {
    class: ['chat-header-content', _vm.isH5 && 'chat-header-h5-content']
  }, [_vm._v(" " + _vm._s(_vm.currentConversationName) + " ")])], 1)]), _vm.props.enableMultilingual === 1 ? _c('div', {
    staticClass: "language-selector"
  }, [_c('div', {
    staticClass: "selected-language-option",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v(" " + _vm._s(_vm.currentLanguageOption.name) + " "), _c('span', {
    staticClass: "arrow",
    class: {
      'arrow-up': _vm.showDropdown
    }
  }, [_c('Icon', {
    attrs: {
      "file": _vm.arrowDown,
      "width": "12px",
      "height": "12px"
    }
  })], 1)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showDropdown ? _c('div', {
    staticClass: "dropdown-popup"
  }, _vm._l(_vm.languageOptionList, function (option) {
    return _c('div', {
      key: option.code,
      class: ['dropdown-item', _vm.currentLanguageOption.code === option.code ? 'dropdown-item-selected' : ''],
      on: {
        "click": function ($event) {
          return _vm.selectLanguage(option);
        }
      }
    }, [_c('div', {
      staticClass: "language"
    }, [_c('div', {
      staticClass: "language-code"
    }, [_vm._v(" " + _vm._s(option.codeForShow) + " ")]), _c('div', {
      staticClass: "language-name"
    }, [_vm._v(" " + _vm._s(option.name) + " ")])]), _vm.currentLanguageOption.code === option.code ? _c('Icon', {
      attrs: {
        "file": _vm.languageSelectedIcon,
        "width": "20px",
        "height": "20px"
      }
    }) : _vm._e()], 1);
  }), 0) : _vm._e()])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }